import type { CSSProperties } from 'react';
import { defaultTheme } from './default-theme';
import type { ThemeOverrides, ThemeTokens } from './theme.entity';

/**
 * Nome da variável CSS de cada token. É um `Record` completo, e não uma
 * conversão automática de camelCase, para que um token novo em `ThemeTokens`
 * sem variável correspondente quebre o typecheck em vez de sumir em silêncio.
 */
const CSS_VARS: Record<keyof ThemeTokens, `--lp-${string}`> = {
  ink: '--lp-ink',
  night: '--lp-night',
  deep: '--lp-deep',
  text: '--lp-text',
  soft: '--lp-soft',
  muted: '--lp-muted',
  subtle: '--lp-subtle',
  accent: '--lp-accent',
  accentStrong: '--lp-accent-strong',
  onAccent: '--lp-on-accent',
  ctaGradient: '--lp-cta-gradient',
  mark: '--lp-mark',
  success: '--lp-success',
  danger: '--lp-danger',
  warning: '--lp-warning',
  backgroundImage: '--lp-bg-image',
  fontFamily: '--lp-font',
};

/**
 * O tema final: o padrão com as sobrescritas por cima. Aceita mais de uma
 * camada para um tenant poder partir de um tema nomeado e ainda ajustar um
 * token — `resolveTheme(temaSaude, { accent: '#…' })`.
 */
export function resolveTheme(...layers: (ThemeOverrides | undefined)[]) {
  return Object.assign({}, defaultTheme, ...layers) as ThemeTokens;
}

/** Os tokens como variáveis CSS, para o `style` da raiz da LP. */
export function themeToCssVars(theme: ThemeTokens): CSSProperties {
  const vars: Record<string, string> = {};
  for (const key of Object.keys(CSS_VARS) as (keyof ThemeTokens)[]) {
    vars[CSS_VARS[key]] = theme[key];
  }
  return vars as CSSProperties;
}
